import Head from 'next/head';
import React, { Fragment } from 'react';
import MobilePlanComparison from '../../components/mobile-plan-comparison/mobilePlanComparison'
import { trackPage } from '../../tracking';
import { getPageViewData } from '../../utils/tracking';

export async function getServerSideProps() {
  return {
    props: { pageName: 'mobile-plan-comparison' }
  }
}

export default function Home(){
  const data = [
    {'Coverage Amount':{
      'flipkart':['sad','Maximum 80% of device price.',],
      'acko':['nutral','Maximum 85% of device price (Amazon Gift Vouchers or Electronic Wallet Credits)'],
      'onsitego':['happy','Maximum 85% of device price.'],
      'icon':'ca'
    }},
    {'Processing Fee':{
      'flipkart':['sad','₹500 or ₹1,000 per repair request.'],
      'acko':['happy','No fees required to raise repair request.'],
      'onsitego':['happy','₹599 or 5% of device cost (whichever is higher)'],
      'icon':'pf'
    }},
    {'No repair within TAT':{
      'flipkart':['sad','₹500 Flipkart Gift Voucher.'],
      'acko':['sad','₹500 Amazon Gift Voucher.'],
      'onsitego':['happy','Replacement device or gift voucher equivalent to the device price.'],
      'icon':'nr'
    }},
    {'Service Coverage':{
      'flipkart':['sad','Pan-India coverage.'],
      'acko':['sad','Selected cities.'],
      'onsitego':['happy','Pan-India coverage.'],
      'icon':'sc'
    }},
    {'Documentation':{
      'flipkart':['sad','Need to submit documents/pictures and bank account info during claims.'],
      'acko':['nutral','No documentation required.'],
      'onsitego':['happy','No documentation required.'],
      'icon':'dt'
    }},
    {'Claim Assessment':{
      'flipkart':['sad','Assessment required before claim. Only accidental damages are covered.'],
      'acko':['sad','Assessment required before claim. Only accidental damages are covered.'],
      'onsitego':['happy','No questions asked policy.'],
      'icon':'ca'
    }},
    {'Self Repair':{
      'flipkart':['sad','Cost of repair reimbursed if repaired from authorised service centre.'],
      'acko':['sad','No option to self-repair.'],
      'onsitego':['happy','Cost of repair reimbursed if repaired from authorised service centre.'],
      'icon':'sr'
    }},
    {'International Damage':{
      'flipkart':['sad','Not Covered.'],
      'acko':['sad','Not Covered.'],
      'onsitego':['happy','Cost of repair can be reimbursed or request for repair after arrival.'],
      'icon':'id'
    }},
  ]
  React.useEffect(()=>{
    trackPage('Mobile Plan Comparison',{...getPageViewData()})
  },[])

    return(
        <Fragment>
          <Head>
              <meta name="description" content="Better than mobile insurance. Guaranteed! Repair or Replacement. With OnsiteGo Spills and Drops Protection for your mobile Phone. Free pick and drop. 100% Cashless. OnsiteGo - India's #1 Rated Mobile Protection Plan."/>
              <meta name="keywords" content="mobile phone insurance, iphone insurance, gadget insurance, best mobile phone insurance, best iphone insurance, cell phone insurance, mobile insurance online, phone warranty, mobile protection"/>
              <title>OnsiteGo- Mobile Protection Plan Comparison</title>
          <link rel="icon" href="/favicon.ico" />
          </Head>
          <MobilePlanComparison data={data}/>
        </Fragment>
    )
}
